import { useMemo } from 'react'
import { useAccount, usePublicClient, useWalletClient } from 'wagmi'

import { useSessionChainId } from '../state/application/hooks'

export const useProviderOrSigner = (withSignerIfPossible = true) => {
  const [chainId] = useSessionChainId()
  const publicClient = usePublicClient({ chainId })
  const { address, isConnected } = useAccount()
  const { data: walletClient } = useWalletClient()

  return useMemo(
    () => withSignerIfPossible && address && isConnected && walletClient ? walletClient : publicClient,
    [address, isConnected, publicClient, walletClient, withSignerIfPossible]
  )
}
